import ORCH_BASE_URL from "../config/orchConfig";
import axios from 'axios';

const backendAPI = axios.create({
  baseURL: ORCH_BASE_URL,
  withCredentials: false,
});

export default backendAPI;


export const fetchLogsAPI = async (workflow_run_id, last_id = null) => {
  try {
    const params = last_id ? { last_id } : {};
    const response = await backendAPI.get(`/logs/poll/${workflow_run_id}`, { params });
    return response.data;
  } catch (error) {
    console.error('❌ Failed to fetch logs:', error.response?.data || error.message);
    throw error;
  }
};

export const fetchSimpleLogsAPI = async (workflow_run_id, step_name, record_status) => {
  try {
    const params = {
      step_name,
      record_status
    };
    const response = await backendAPI.get(`/logs/simple_logs/${workflow_run_id}`, { params });
    return response.data;
  } catch (error) {
    console.error('❌ Failed to fetch simple logs:', error.response?.data || error.message);
    throw error;
  }
};


